import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";
import { api, imgSrc } from "@/lib/api";
import { t } from "@/lib/i18n";
import { Avatar } from "@/components/PersonCard";

const StoryTile = ({ s, i }) => (
  <Link to={`/person/${s.person_id}`} className="group rise block rounded-3xl border border-[#E5DEC9] bg-white overflow-hidden transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_16px_40px_-20px_rgba(30,58,43,0.4)]"
    style={{ animationDelay: `${i * 0.06}s` }} data-testid={`feed-story-${s.story_id}`}>
    {s.photos[0] && <img src={imgSrc(s.photos[0])} alt="" loading="lazy" className="w-full h-44 object-cover" />}
    <div className="p-6 space-y-3">
      <div className="flex items-center gap-2.5">
        <Avatar p={s.person} size="w-8 h-8 text-[11px]" />
        <span className="text-sm font-medium text-[#1E3A2B]">{s.person.name}</span>
        {s.year && <span className="font-mono text-xs text-[#7E8E85]">· {s.year}</span>}
      </div>
      <h3 className="font-serif text-xl font-semibold leading-snug group-hover:text-[#D96B43] transition-colors">{s.title}</h3>
      <p className="text-sm text-[#52635B] leading-relaxed line-clamp-3">{s.body}</p>
      <p className="text-xs text-[#7E8E85] flex items-center justify-between">
        <span>{t("by")} {s.author}</span>
        <ArrowRight className="w-4 h-4 text-[#D96B43] transition-transform group-hover:translate-x-1" />
      </p>
    </div>
  </Link>
);

export const StoryFeed = () => {
  const [stories, setStories] = useState([]);
  useEffect(() => { api.get("/stories/recent", { params: { limit: 6 } }).then(({ data }) => setStories(data)); }, []);
  if (stories.length === 0) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-8 pb-14 space-y-8" data-testid="story-feed">
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#D96B43] mb-2 flex items-center gap-1.5"><BookOpen className="w-3.5 h-3.5" />{t("Family stories")}</p>
        <h2 className="font-serif text-2xl sm:text-3xl font-semibold">{t("Latest family memories")}</h2>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {stories.map((s, i) => <StoryTile key={s.story_id} s={s} i={i} />)}
      </div>
    </section>
  );
};
